module.exports = __webpack_public_path__ + "img/consumer-image-intro-page-Referra-750x388.3b83b9c5.png";